export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.5.14-1256.04",
  commitId: "cfdabb938a11331abc1b7bc0654ac8861279d274",
  commitTime: "2026-05-14T12:56:04.000Z",
});
